@if (hasOverrideWithoutOrigamiData()) {
  <div class="data-mismatch-warning"
       data-test="sub-coverage-origami-mismatch-warning"
       role="alert"
  >
    {{ OVERRIDE_WITHOUT_ORIGAMI_WARNING }}
  </div>
}
<div class="comparison-grid expanded-mode"
     data-test="sub-coverage-comparison-grid"
     [formGroup]="form()"
>

  <!-- Period Row -->
  <div class="origami-field">
    <albert-period controlName="externalValue"
                   data-test="external-period"
                   periodFromGroupName="periodFrom"
                   periodFromInputId="ext_periodFrom"
                   periodFromLabel="Period From"
                   periodToGroupName="periodTo"
                   periodToInputId="ext_periodTo"
                   periodToLabel="Period To"
                   [disabled]="true"
    />
  </div>
  <div class="override-cell">
    <albert-override-wrapper data-test="override-wrapper-period"
                             tooltipLabel="Period"
                             [disabled]="!canEdit()"
                             [isVisible]="isFieldVisible('periodFrom') || isFieldVisible('periodTo')"
                             (visibilityChange)="toggleField('periodFrom'); toggleField('periodTo')"
    >
      <albert-period controlName="localValue"
                     data-test="local-period"
                     periodFromGroupName="periodFrom"
                     periodFromInputId="loc_periodFrom"
                     periodFromLabel="Period From"
                     periodToGroupName="periodTo"
                     periodToInputId="loc_periodTo"
                     periodToLabel="Period To"
                     [disabled]="!canEdit()"
      />
    </albert-override-wrapper>
  </div>

  <!-- Policy Number Row -->
  <div class="origami-field">
    <albert-input controlName="externalValue"
                  data-test="external-policy-number"
                  groupName="policyNumber"
                  inputId="ext_policyNumber"
                  label="Policy Number"
                  [disabled]="true"
    />
  </div>
  <div class="override-cell">
    <albert-override-wrapper data-test="override-wrapper-policy-number"
                             tooltipLabel="Policy Number"
                             [disabled]="!canEdit()"
                             [isVisible]="isFieldVisible('policyNumber')"
                             (visibilityChange)="toggleField('policyNumber')"
    >
      <albert-input controlName="localValue"
                    data-test="override-policy-number"
                    groupName="policyNumber"
                    inputId="loc_policyNumber"
                    label="Policy Number"
                    [disabled]="!canEdit()"
      />
    </albert-override-wrapper>
  </div>

  <!-- Limit Row -->
  @if (controls.limit) {
    <div class="origami-field">
      <albert-limit controlName="externalValue"
                    currencyGroupName="limit.currency"
                    currencyInputId="ext_limitCurrency"
                    limitGroupName="limit.value"
                    limitInputId="ext_limit"
                    limitLabel="Limit"
                    [disabled]="true"
      />
    </div>
    <div class="override-cell">
      <albert-override-wrapper data-test="override-wrapper-limit"
                               tooltipLabel="Limit"
                               [disabled]="!canEdit()"
                               [isVisible]="isFieldVisible('limit')"
                               (visibilityChange)="toggleField('limit')"
      >
        <albert-limit controlName="localValue"
                      currencyGroupName="limit.currency"
                      currencyInputId="loc_limitCurrency"
                      limitGroupName="limit.value"
                      limitInputId="loc_limit"
                      limitLabel="Limit"
                      [disabled]="!canEdit()"
        />
      </albert-override-wrapper>
    </div>
  }

  <!-- Spares Deductible Row -->
  @if (controls.sparesDeductible) {
    <div class="origami-field">
      <albert-limit controlName="externalValue"
                    currencyGroupName="sparesDeductible.currency"
                    currencyInputId="ext_sparesDeductibleCurrency"
                    limitGroupName="sparesDeductible.value"
                    limitInputId="ext_sparesDeductible"
                    limitLabel="Spares Deductible"
                    [disabled]="true"
      />
    </div>
    <div class="override-cell">
      <albert-override-wrapper data-test="override-wrapper-sparesDeductible"
                               tooltipLabel="Spares Deductible"
                               [disabled]="!canEdit()"
                               [isVisible]="isFieldVisible('sparesDeductible')"
                               (visibilityChange)="toggleField('sparesDeductible')"
      >
        <albert-limit controlName="localValue"
                      currencyGroupName="sparesDeductible.currency"
                      currencyInputId="loc_sparesDeductibleCurrency"
                      limitGroupName="sparesDeductible.value"
                      limitInputId="loc_sparesDeductible"
                      limitLabel="Spares Deductible"
                      [disabled]="!canEdit()"
        />
      </albert-override-wrapper>
    </div>
  }

  <!-- Personal Injury Sublimit Row -->
  @if (controls.personalInjurySublimit) {
    <div class="origami-field">
      <albert-limit controlName="externalValue"
                    currencyGroupName="personalInjurySublimit.currency"
                    currencyInputId="ext_personalInjurySublimitCurrency"
                    limitGroupName="personalInjurySublimit.value"
                    limitInputId="ext_personalInjurySublimit"
                    limitLabel="Personal Injury Sublimit"
                    [disabled]="true"
      />
    </div>
    <div class="override-cell">
      <albert-override-wrapper data-test="override-wrapper-personalInjurySublimit"
                               tooltipLabel="Personal Injury Sublimit"
                               [disabled]="!canEdit()"
                               [isVisible]="isFieldVisible('personalInjurySublimit')"
                               (visibilityChange)="toggleField('personalInjurySublimit')"
      >
        <albert-limit controlName="localValue"
                      currencyGroupName="personalInjurySublimit.currency"
                      currencyInputId="loc_personalInjurySublimitCurrency"
                      limitGroupName="personalInjurySublimit.value"
                      limitInputId="loc_personalInjurySublimit"
                      limitLabel="Personal Injury Sublimit"
                      [disabled]="!canEdit()"
        />
      </albert-override-wrapper>
    </div>
  }

  <!-- Aggregate Limit Row -->
  @if (controls.aggregateLimit) {
    <div class="origami-field">
      <albert-limit controlName="externalValue"
                    currencyGroupName="aggregateLimit.currency"
                    currencyInputId="ext_aggregateLimitCurrency"
                    limitGroupName="aggregateLimit.value"
                    limitInputId="ext_aggregateLimit"
                    limitLabel="Aggregate Limit"
                    [disabled]="true"
      />
    </div>
    <div class="override-cell">
      <albert-override-wrapper data-test="override-wrapper-aggregateLimit"
                               tooltipLabel="Aggregate Limit"
                               [disabled]="!canEdit()"
                               [isVisible]="isFieldVisible('aggregateLimit')"
                               (visibilityChange)="toggleField('aggregateLimit')"
      >
        <albert-limit controlName="localValue"
                      currencyGroupName="aggregateLimit.currency"
                      currencyInputId="loc_aggregateLimitCurrency"
                      limitGroupName="aggregateLimit.value"
                      limitInputId="loc_aggregateLimit"
                      limitLabel="Aggregate Limit"
                      [disabled]="!canEdit()"
        />
      </albert-override-wrapper>
    </div>
  }

  <!-- Grounding Liability Sublimit Row -->
  @if (controls.groundingLiabilitySublimit) {
    <div class="origami-field">
      <albert-limit controlName="externalValue"
                    currencyGroupName="groundingLiabilitySublimit.currency"
                    currencyInputId="ext_groundingLiabilitySublimitCurrency"
                    limitGroupName="groundingLiabilitySublimit.value"
                    limitInputId="ext_groundingLiabilitySublimit"
                    limitLabel="Grounding Liability Sublimit"
                    [disabled]="true"
      />
    </div>
    <div class="override-cell">
      <albert-override-wrapper data-test="override-wrapper-groundingLiabilitySublimit"
                               tooltipLabel="Grounding Liability Sublimit"
                               [disabled]="!canEdit()"
                               [isVisible]="isFieldVisible('groundingLiabilitySublimit')"
                               (visibilityChange)="toggleField('groundingLiabilitySublimit')"
      >
        <albert-limit controlName="localValue"
                      currencyGroupName="groundingLiabilitySublimit.currency"
                      currencyInputId="loc_groundingLiabilitySublimitCurrency"
                      limitGroupName="groundingLiabilitySublimit.value"
                      limitInputId="loc_groundingLiabilitySublimit"
                      limitLabel="Grounding Liability Sublimit"
                      [disabled]="!canEdit()"
        />
      </albert-override-wrapper>
    </div>
  }

  <!-- Confiscation Sublimit Row -->
  @if (controls.confiscationSublimit) {
    <div class="origami-field">
      <albert-limit controlName="externalValue"
                    currencyGroupName="confiscationSublimit.currency"
                    currencyInputId="ext_confiscationSublimitCurrency"
                    limitGroupName="confiscationSublimit.value"
                    limitInputId="ext_confiscationSublimit"
                    limitLabel="Confiscation Sublimit"
                    [disabled]="true"
      />
    </div>
    <div class="override-cell">
      <albert-override-wrapper data-test="override-wrapper-confiscationSublimit"
                               tooltipLabel="Confiscation Sublimit"
                               [disabled]="!canEdit()"
                               [isVisible]="isFieldVisible('confiscationSublimit')"
                               (visibilityChange)="toggleField('confiscationSublimit')"
      >
        <albert-limit controlName="localValue"
                      currencyGroupName="confiscationSublimit.currency"
                      currencyInputId="loc_confiscationSublimitCurrency"
                      limitGroupName="confiscationSublimit.value"
                      limitInputId="loc_confiscationSublimit"
                      limitLabel="Confiscation Sublimit"
                      [disabled]="!canEdit()"
        />
      </albert-override-wrapper>
    </div>
  }

</div>

<albert-reinsurance-form data-test="albert-reinsurance-form"
                         [form]="controls.reinsurance"
                         [isCreateMode]="isCreateMode()"
                         [memberExternalId]="memberExternalId()"
                         [policyStatus]="policyStatus()"
/>
